<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees class="row my-5"></app-nav-gestion-donnees>

	<div *ngIf="parcours" class="my-3 theme-main-color">
		<div class="">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i>Parcours de
						{{ parcours?.beneficiaire?.firstName | titlecase }}
						{{ parcours?.beneficiaire?.lastName | titlecase }}</span
					>
				</div>

				<!-- <div *ngIf="isDeletable" class="">
					<a
						(click)="openConfirmDeleteModal(deleteMissionPlace)"
						class="btn theme-red-button px-3"
					>
						Supprimer la fiche
					</a>
				</div> -->
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="row rounded bg-light">
			<div *ngIf="isFormReadOnly">
				<div class="row my-4">
					<div class="col">
						<label
							for="creationDate"
							class="form-label theme-main-color fw-bold"
							>Date de création</label
						>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext">{{
							parcours.creationDate | date : 'dd/MM/yy'
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<label for="beneficiaire" class="form-label fw-bold"
						>Bénéficiaire</label
					>
					<span *ngIf="isFormReadOnly" class="form-control-plaintext ps-3"
						>{{ parcours?.beneficiaire?.firstName | titlecase }}
						{{ parcours?.beneficiaire?.lastName | titlecase }}</span
					>
				</div>
				<div class="row my-4">
					<label for="prescriber" class="form-label fw-bold"
						>Prescripteur</label
					>
					<span *ngIf="isFormReadOnly" class="form-control-plaintext ps-3">{{
						parcours?.prescriber?.name | titlecase
					}}</span>
				</div>

				<!-- <div class="row my-4">
					<label for="prescriber" class="form-label fw-bold"
						>Qualification</label
					>
					<span
						*ngIf="isFormReadOnly && parcours.missionQualification"
						class="form-control-plaintext ps-3"
						>Prévue le
						{{
							parcours?.missionQualification?.missionRequest?.date
								| date : 'dd/MM/yy'
						}}
						<span
							*ngIf="
								isFormReadOnly &&
								parcours.missionQualification &&
								parcours.qualificator
							"
							>{{
								'par ' +
									parcours?.qualificator.firstName +
									' ' +
									parcours?.qualificator.lastName
							}}</span
						>
					</span>

					<span
						*ngIf="isFormReadOnly && !parcours.missionQualification"
						class="form-control-plaintext ps-3"
					>
						<button
							class="btn theme-main-color-button mx-3 px-3"
							(click)="createMissionQualification()"
						>
							Programmer la qualification
						</button>
					</span>
					<span
						*ngIf="
							isFormReadOnly &&
							parcours.missionQualification &&
							!parcours.qualificator
						"
						class="form-control-plaintext ps-3"
					>
						<button
							class="btn theme-main-color-button mx-3 px-3"
							(click)="openModalSelectionQualificator()"
						>
							Sélectionner le professionnel de qualification
						</button>
					</span>
				</div> -->

				<div class="row my-4">
					<div class="col">
						<label for="status" class="form-label theme-main-color fw-bold"
							>Statut</label
						>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext">{{
							parcours.status
						}}</span>
					</div>
				</div>

				<div class="row my-4">
					<div class="col">
						<label for="inputNotes" class="form-label theme-main-color fw-bold"
							>Notes</label
						>
						<span *ngIf="isFormReadOnly" class="form-control-plaintext">{{
							parcours.notes
						}}</span>
					</div>
				</div>
			</div>
			<!-- <app-mission-place-form
				*ngIf="!isFormReadOnly"
				[missionPlace]="missionPlace"
				[form]="missionPlaceDetailForm"
				[isAddForm]="false"
				[isAddressSelected]="isAddressSelected"
				[isAddressDefault]="isAddressDefault"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()"
			></app-mission-place-form> -->
		</div>
		<div class="row my-4">
			<!-- <div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm(false)"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="
						!missionPlaceDetailForm.valid || isValidateButtonClicked.value
					"
					class="btn theme-green-button"
					type="submit"
					form="form"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div> -->
		</div>
	</div>
</div>
